import { render, staticRenderFns } from "./IconSquareClose.vue?vue&type=template&id=dae0afcc"
import script from "./IconSquareClose.vue?vue&type=script&lang=js"
export * from "./IconSquareClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports